export default __webpack_public_path__ + "static/media/04.eb1b5ea4.webp";